import { makeStyles } from '@mui/styles';
import Blade from 'apollo-react/components/Blade';
import classNames from 'classnames';
import _ from 'lodash';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { PILGRIM_TOP_MENU_HEIGHT } from '../../../constants/SizeConstants';
import { useFormSelector } from '../../../custom-hooks';
import { getUITA } from '../../../utils/commonUtils';
import { checkActiveContainers, removeSelectedSubGrid } from '../../actions/runtime.actions';
import { FORM_KEYS } from '../../constants/form-manager.constants';
import { FormContext, SSModalContext } from '../../context';
import SSSubGrid from '../../controls/ssSubGrid';
import { formHasButtons } from '../../selectors/form-manager.selectors';
import { getSelectedSubGridsWithActualIndexes } from '../../selectors/runtime.selectors';
import { equalityFn } from '../../utils/form-manager.utils';

const useStyles = makeStyles({
  root: {
    '& > :first-child': {
      boxShadow: 'none',
    },
  },
  withFormButtons: {
    '& > :first-child': {
      height: 'calc(100% - 128px) !important',
    },
  },
  bodySmallPaddings: {
    paddingLeft: '16px !important',
    paddingRight: '16px !important',
  },
  headerSmallPaddings: {
    paddingLeft: '16px !important',
  },
});

const MobileSelectedSubGrids = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const formKey = useContext(FormContext);
  const subGrids = useFormSelector(getSelectedSubGridsWithActualIndexes, {}, equalityFn);
  const isFormButtonsAvailable = useFormSelector(formHasButtons, { formKey: FORM_KEYS.STEP });

  const isOpen = subGrids.length;
  const {
    title,
    rowId,
    subgridId,
    gridIndex,
    row,
    isDetail,
    viewOnly,
    ssModalContext = {},
    isParentlessTable,
    parentGridInstanceId,
  } = _.last(subGrids) ?? {};

  const handleClose = () => {
    dispatch(removeSelectedSubGrid(rowId, formKey));
    dispatch(checkActiveContainers(formKey));
  };

  const subGridComponent = (
    <div data-is-inside-blade="true" data-parent-grid-instanceid={parentGridInstanceId}>
      <SSSubGrid
        subgridId={subgridId}
        index={gridIndex}
        row={row}
        isDetail={isDetail}
        viewOnly={viewOnly}
        isParentlessTable={isParentlessTable}
      />
    </div>
  );

  const subGridComponentWithModalContext = ssModalContext.isInModal ? (
    <SSModalContext.Provider value={ssModalContext}>{subGridComponent}</SSModalContext.Provider>
  ) : (
    subGridComponent
  );

  return (
    <Blade
      className={classNames(
        classes.root,
        !ssModalContext.isInModal && isFormButtonsAvailable ? classes.withFormButtons : ''
      )}
      open={isOpen}
      side="right"
      marginTop={PILGRIM_TOP_MENU_HEIGHT}
      title={title}
      width={window.innerWidth}
      onClose={handleClose}
      ui-ta={getUITA(isOpen ? `BladeComponent_${subGrids.length - 1}` : '')}
      bodyProps={{ 'ui-ta': 'ScrollingElement', className: classes.bodySmallPaddings }}
      headerProps={{ className: classes.headerSmallPaddings }}
      alwaysExpanded
    >
      {isOpen && subGridComponentWithModalContext}
    </Blade>
  );
};

export default MobileSelectedSubGrids;
